import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import React, { memo, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { useLocation } from 'react-router';

import { getHelpCenterLink, shopLink } from '../../../../marketplace-links';
import { neutral } from '../../../../styles/mui/colors';
import IconMenu from '../../../Icons/IconMenu';
import IconUser from '../../../Icons/IconUser';
import Link from '../../../Links/Link/Link';

const LoginMenuComponent = ({ isAuthenticatedOrJustHydrated, locale }) => {
  const location = useLocation();
  const [loginMenuAnchorEl, setLoginMenuAnchorEl] = useState(null);
  const loginMenuOpen = Boolean(loginMenuAnchorEl);

  const handleLoginMenuClick = (event) => {
    setLoginMenuAnchorEl(event.currentTarget);
  };

  const handleLoginMenuClose = () => {
    setLoginMenuAnchorEl(null);
  };

  const signupLink = isAuthenticatedOrJustHydrated ? null : (
    <MenuItem
      component={Link}
      onClick={handleLoginMenuClose}
      to={{ name: 'SignupPage', state: { from: `${location.pathname}${location.search}${location.hash}` } }}
    >
      <FormattedMessage id="TopbarDesktop.signup" />
    </MenuItem>
  );

  const loginLink = isAuthenticatedOrJustHydrated ? null : (
    <MenuItem
      component={Link}
      onClick={handleLoginMenuClose}
      to={{ name: 'SigninPage', state: { from: `${location.pathname}${location.search}${location.hash}` } }}
    >
      <FormattedMessage id="TopbarDesktop.login" />
    </MenuItem>
  );

  return (
    <Box>
      <IconButton
        aria-controls="login-menu"
        aria-haspopup="true"
        aria-label="account of current user"
        color="inherit"
        edge="end"
        onClick={handleLoginMenuClick}
        sx={{ borderRadius: 2, border: `1px solid ${neutral[200]}`, mr: 0, ml: 1 }}
      >
        <IconMenu />
        <IconUser sx={{ ml: 1 }} />
      </IconButton>
      <Menu
        anchorEl={loginMenuAnchorEl}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        id="login-menu"
        onClose={handleLoginMenuClose}
        open={loginMenuOpen}
        transformOrigin={{
          vertical: -16,
          horizontal: 'right',
        }}
      >
        {signupLink}
        {loginLink}
        <Divider />
        <MenuItem component={Link} href={shopLink} onClick={handleLoginMenuClose} target="_blank">
          <FormattedMessage id="SectionShop.button" />
        </MenuItem>
        <MenuItem component={Link} onClick={handleLoginMenuClose} to={{ name: 'NewListingPage' }}>
          <FormattedMessage id="TopbarDesktop.becomeHost" />
        </MenuItem>
        <MenuItem
          component={Link}
          href={getHelpCenterLink(locale)}
          onClick={handleLoginMenuClose}
        >
          <FormattedMessage id="Footer.helpCenter" />
        </MenuItem>
      </Menu>
    </Box>
  );
};

LoginMenuComponent.displayName = 'LoginMenu';

const LoginMenu = memo(LoginMenuComponent);

export default LoginMenu;
